import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesDeliveryFees } from "../../constants";
import { UpdateDeliveryFeeRequestBody } from "./updateDeliveryFee.types";

export const requestUpdateDeliveryFee = async ({
  id,
  ...restBody
}: UpdateDeliveryFeeRequestBody): Promise<void> => {
  return await instance.patch(
    buildUrl(ApiRoutesDeliveryFees.DeliveryFees, id),
    restBody
  );
};
